import { memo } from 'react';

type Props = {
	productName: string;
};

/**
 * Normalises a product headline string and renders it as styled spans.
 * Uses Unicode non-breaking spaces (U+00A0) instead of &nbsp; HTML entities.
 */
function formatHeadline(headline: string): React.ReactElement {
	const normalized = headline
		.replace(/DER STANDARD/g, 'DER\u00A0STANDARD')
		.replace(/PUR Jahresabo/g, 'PUR\u00A0Jahresabo')
		.replace(/\s\+\s/g, '+');

	if (!normalized.includes(' ')) {
		return <span>{normalized}</span>;
	}

	return (
		<>
			{normalized.split(' ').map((word, idx) =>
				idx === 0 ? (
					<span key={idx}>
						<em>
							<small>{word}</small>
						</em>
					</span>
				) : (
					<span key={idx}>{word}</span>
				)
			)}
		</>
	);
}

const ProductHeading = memo(({ productName }: Props) => (
	<h2 className="product-headline format--marketing-headline">{formatHeadline(productName)}</h2>
));

ProductHeading.displayName = 'ProductHeading';

export { ProductHeading };
